import "../css/style.css"
import Navbar from "../components/navbar"
import { ImPower } from "react-icons/im"
import { FaUser } from "react-icons/fa"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { Select, Space } from "antd"
import { CiMedicalCross } from "react-icons/ci"
import { GiStethoscope } from "react-icons/gi"
import { AiFillMail, AiOutlineClockCircle } from "react-icons/ai"
import { FiUser, FiUsers } from "react-icons/fi"
import { locations } from "../components/locations"
import { AiFillInfoCircle, AiFillPhone } from "react-icons/ai"
import Footer from "../components/footer"
import Sliders from "../components/slider"
import { Link } from "react-router-dom"
import ProgressBar from "../components/progress-bar"

function App() {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [specialityOptions, setSpecialityOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [specialitySearch, setSpecialitySearch] = useState(specialityOptions[0])
    const [locationOptions, setLocationOptions] = useState(locations)
    const [locationSearch, setLocationSearch] = useState(locationOptions[0])
    const { Option } = Select;

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    return (
        <Navbar active={"home"} navShow={navShown}>
            <div>
                <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                    <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                    <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                        X
                    </span>
                    <h1 className="text-center text-white py-4 w-full">Home</h1>
                </div>
                <div className="h-60 bg-new_york bg-cover bg-center bg-no-repeat flex items-center relative top-14">
                    <div className="w-[95%] m-auto">
                        <h1 className="self-start text-[38px] text-white font-bold">Welcome, Sarah!</h1>
                        <div className="bg-[#ffedac] flex items-center gap-x-2 p-2">
                            <ImPower />
                            <p>Crisis response jobs available.
                            </p>
                            <button className="border-none text-sm">
                                <Link to={"/search-jobs"} className="uppercase underline">View Jobs</Link>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="w-[95%] py-4 px-10 m-auto rounded-lg relative top-10 z-10 bg-white " style={{
                    boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                }}>
                    <div>
                        <h1 className="font-semibold">Application progress</h1>
                        <div className="my-3">
                            <ProgressBar active={"personal info"} />
                        </div>
                        <div className="flex justify-between items-center flex-col lg:flex-row">
                            <div className="w-full lg:w-[60%] py-6 text-center">
                                <p>Your personal information is needed for many reasons — from facilities contacting you for interviews to fun things like gifts from Aya! Plus, we use your job preferences to find positions with shifts and locations that fit your lifestyle.
                                </p>
                            </div>
                            <div className="w-[40%] flex flex-col gap-4 p-3">
                                <div className="flex justify-center items-center">
                                    <Link to={"/personal-info"} className="flex justify-center items-center bg-[#47d0e6] min-w-[220px] min-h-[35px] rounded-full uppercase text-[#034a59] font-semibold">
                                        let's get started
                                    </Link>
                                </div>
                                <div className="flex justify-center items-center">
                                    <Link to={"/personal-info"} className="flex justify-center items-center bg-[#47d0e6] min-w-[220px] min-h-[35px] rounded-full uppercase text-[#034a59] font-semibold">
                                        Resume Application
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-[95%] flex flex-col lg:flex-row gap-3 justify-between bg-white m-auto mt-32 z-10 ">
                    <div className="flex flex-col lg:w-[60%] w-full">
                        <div className=" p-4 rounded-[20px]" style={{ boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}>
                            <h1 className="font-semibold text-[24px]">Jobs you might like</h1>
                            <div className="px-6 py-2 flex justify-center">
                                <Sliders>
                                    <div className="border-2 min-w-40 p-2">
                                        <span className="uppercase text-[16px] block font-bold">
                                            Cleveland, oh <CiMedicalCross className="font-bold text-black" /> uh cleveland medical center
                                        </span>
                                        <spna className="block">
                                            ICU <GiStethoscope className="inline font-bold" />
                                        </spna>
                                        <span className="block">
                                            3x12 Night / 3x12 Day
                                            13 weeks <AiOutlineClockCircle className="inline font-bold text-black" />
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                $
                                            </span>
                                            <span className="pl-4">
                                                $2588.31 to $2751.75 weekly
                                            </span>
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                <FiUsers />
                                                5 Openings
                                            </span>
                                        </span>
                                    </div>
                                    <div className="border-2 min-w-40 p-2">
                                        <span className="uppercase text-[16px] block font-bold">
                                            Cleveland, oh <CiMedicalCross className="font-bold text-black" /> uh cleveland medical center
                                        </span>
                                        <spna className="block">
                                            ICU <GiStethoscope className="inline font-bold" />
                                        </spna>
                                        <span className="block">
                                            3x12 Night / 3x12 Day
                                            13 weeks <AiOutlineClockCircle className="inline font-bold text-black" />
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                $
                                            </span>
                                            <span className="pl-4">
                                                $2588.31 to $2751.75 weekly
                                            </span>
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                <FiUsers />
                                                5 Openings
                                            </span>
                                        </span>
                                    </div>
                                </Sliders>
                                {/* <div className="flex gap-2 justify-center">
                                    <div className="border-2 min-w-40 p-2">
                                        <span className="uppercase text-[16px] block font-bold">
                                            Cleveland, oh <CiMedicalCross className="font-bold text-black" /> uh cleveland medical center
                                        </span>
                                        <spna className="block">
                                            ICU <GiStethoscope className="inline font-bold" />
                                        </spna>
                                        <span className="block">
                                            3x12 Night / 3x12 Day
                                            13 weeks <AiOutlineClockCircle className="inline font-bold text-black" />
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                $
                                            </span>
                                            <span className="pl-4">
                                                $2588.31 to $2751.75 weekly
                                            </span>
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                <FiUsers />
                                                5 Openings
                                            </span>
                                        </span>
                                    </div>
                                    <div className="border-2 min-w-40 p-2">
                                        <span className="uppercase text-[16px] block font-bold">
                                            Cleveland, oh <CiMedicalCross className="font-bold text-black" /> uh cleveland medical center
                                        </span>
                                        <spna className="block">
                                            ICU <GiStethoscope className="inline font-bold" />
                                        </spna>
                                        <span className="block">
                                            3x12 Night / 3x12 Day
                                            13 weeks <AiOutlineClockCircle className="inline font-bold text-black" />
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                $
                                            </span>
                                            <span className="pl-4">
                                                $2588.31 to $2751.75 weekly
                                            </span>
                                        </span>
                                        <span className="block">
                                            <span className="font-bold">
                                                <FiUsers />
                                                5 Openings
                                            </span>
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="p-4 mt-3 rounded-[20px]" style={{ boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}>
                            <h1 className="font-semibold text-[24px] capitalize">Cities with best job oppurtunities</h1>
                            <div className="flex justify-center gap-3 flex-wrap mt-3">
                                <Link to={"/search-jobs"}>
                                    <div>
                                        <img src="https://cdn.ayahealthcare.com/marketingpublic/columbus_oh--200x200.png" alt="" className="w-28 h-28 rounded-full" />
                                    </div>
                                    <div className="text-center">
                                        Coumbus, OH
                                    </div>
                                </Link>
                                <Link to={"/search-jobs"}>
                                    <div>
                                        <img src="https://cdn.ayahealthcare.com/marketingpublic/columbus_oh--200x200.png" alt="" className="w-28 h-28 rounded-full" />
                                    </div>
                                    <div className="text-center">
                                        Coumbus, OH
                                    </div>
                                </Link>
                                <Link to={"/search-jobs"}>
                                    <div>
                                        <img src="https://cdn.ayahealthcare.com/marketingpublic/columbus_oh--200x200.png" alt="" className="w-28 h-28 rounded-full" />
                                    </div>
                                    <div className="text-center">
                                        Coumbus, OH
                                    </div>
                                </Link>
                                <Link to={"/search-jobs"}>
                                    <div>
                                        <img src="https://cdn.ayahealthcare.com/marketingpublic/columbus_oh--200x200.png" alt="" className="w-28 h-28 rounded-full" />
                                    </div>
                                    <div className="text-center">
                                        Coumbus, OH
                                    </div>
                                </Link>
                                <Link to="/search-jobs">
                                    <div>
                                        <img src="https://cdn.ayahealthcare.com/marketingpublic/columbus_oh--200x200.png" alt="" className="w-28 h-28 rounded-full" />
                                    </div>
                                    <div className="text-center">
                                        Coumbus, OH
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-[40%] flex flex-col rounded-[20px] w-full p-6 mt-3 lg:mt-0" style={{ boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}>
                        <span className="font-semibold block text-lg">Your next adventure's just a search away!</span>
                        <div>
                            <p className="py-2 font-semibold">Your speciality</p>
                            <Select
                                mode="multiple"
                                style={{
                                    width: '100%',
                                }}
                                placeholder="select one country"
                                defaultValue={specialityOptions}
                                optionLabelProp="label"
                                value={specialitySearch}
                                onChange={(e) => setSpecialitySearch(e)}
                            >

                                {
                                    specialityOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                        <div className="lg:mt-10">
                            <p className="py-2 font-semibold">Location</p>
                            <Select
                                mode="multiple"
                                style={{
                                    width: '100%',
                                }}
                                placeholder="select one country"
                                defaultValue={locationSearch}
                                optionLabelProp="label"
                                value={locationSearch}
                                onChange={(e) => setLocationSearch(e)}
                            >

                                {
                                    locationOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                        <div className="bg-[#eceff1] p-2 lg:mt-10 mt-3 text-[12px]">
                            <div className="flex items-center gap-2">
                                <input type="radio" name="" id="" />
                                <p>Compact license state</p>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="radio" name="" id="" />
                                <p>Compact license state</p>
                            </div>
                            <div className="flex my-3 items-start gap-x-1" >
                                <AiFillInfoCircle className="text-[40px] relative -top-[10px]" />
                                <p>
                                    Many jobs don’t require a license in hand to apply. Your recruiter can
                                    help plan for your ideal locations. We'll get you licensed quickly!
                                </p>
                            </div>
                        </div>
                        <div className="mt-4">
                            <button className="bg-[#47d0e6] px-8 py-1  rounded-full uppercase text-[#034a59] text-sm font-semibold">
                                Search jobs
                            </button>
                        </div>
                    </div>
                </div>

                <div className="w-[95%] m-auto p-4 rounded-[20px] mt-4" style={{ boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", }}>
                    <h1 className="font-bold">
                        Hi, let's plan your travel career together!
                    </h1>
                    <p>SR. SURGICAL SERVICES RECRUITER IV</p>
                    <p className="font-semibold">
                        SAMUEL VERGARA
                    </p>
                    <div className="flex items-center">
                        <AiFillPhone />
                        <a href="tel:(858) 666-6615">(858) 666-6615</a>
                    </div>
                    <div className="flex items-center">
                        <AiFillMail />
                        <a href="mailto:example@gmail.com">example@gmail.com</a>
                    </div>
                </div>
                <div className="mt-10">
                    <Footer active={"home"} />
                </div>
            </div>
        </Navbar>
    )
}

export default App